import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '../../../Skeleton';
import { DropdownTypes } from '../../helper';
import { MultiSelectionList } from '../../MultiSelectionList';
import { SingleSelectionList } from '../../SingleSelectionList';
function DropdownComponent(props) {
  const {
    dropdownType,
    isLoading
  } = props;
  function getComponent() {
    switch (dropdownType) {
      case DropdownTypes.SINGLE_SELECTION:
        return /*#__PURE__*/React.createElement(SingleSelectionList, props);
      case DropdownTypes.MULTI_SELECTION:
        return /*#__PURE__*/React.createElement(MultiSelectionList, props);
      default:
        return null;
    }
  }
  return isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '.25rem 1rem',
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 24
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: 18,
    style: {
      marginLeft: '.5rem'
    }
  })), Array(4).fill(true).map((_, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        padding: '.25rem 1rem',
        display: 'flex'
      }
    }, /*#__PURE__*/React.createElement(Skeleton, {
      height: 24,
      width: "100%"
    }));
  })) : getComponent();
}
DropdownComponent.defaultProps = {
  isLoading: false,
  dropdownType: 'singleSelection'
};
DropdownComponent.propTypes = {
  isLoading: PropTypes.bool,
  dropdownType: PropTypes.string
};
export default DropdownComponent;